/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentType } from '../../models/document-type';
import { DocumentUploadResponseDto } from '../../models/document-upload-response-dto';

export interface Upload$Params {
      body: {

/**
 * One or more files to upload. Repeat the field per file.
 */
'File': Array<Blob>;

/**
 * Names of the files, in the same order as the File parts.
 */
'FileName'?: Array<string>;

/**
 * Document types, in the same order as the File parts.
 */
'DocumentType'?: Array<DocumentType>;
}
}

export function upload(http: HttpClient, rootUrl: string, params: Upload$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentUploadResponseDto>> {
  const rb = new RequestBuilder(rootUrl, upload.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentUploadResponseDto>;
    })
  );
}

upload.PATH = '/api/Document/upload';
